import createApi from 'api/createApi';
import qs from 'query-string';

export const tags = {
	email__attach__upload: 'mw/email/attach/upload',
	email__attach__delete: 'mw/email/attach/delete',
	email__attach__list: 'mw/email/attach/list',
	email__inbox__short: 'mw/email/inbox/short',
	email__reply: 'mw/email/reply',
	email__forward: 'mw/email/forward',
	email__create: 'mw/email/create',
};

export const emailApi = createApi({
	reducerPath: 'mw/emailApi',

	endpoints: (builder) => ({
		emailAttachUpload: builder.mutation({
			query: (body) => ({
				method: 'POST',
				url: '/mw/email/attach/upload',
				body,
				file: true,
			}),
			providesTags: [tags.email__attach__upload],
		}),
		emailAttachDelete: builder.mutation({
			query: (body) => ({
				method: 'POST',
				url: '/mw/email/attach/delete',
				body,
			}),
			providesTags: [tags.email__attach__delete],
		}),
		emailAttachList: builder.mutation({
			query: (body) => ({
				method: 'GET',
				url: `/mw/email/attach/list?${qs.stringify(body)}`,
			}),
			providesTags: [tags.email__attach__list],
		}),
	emailInboxShort: builder.mutation({
			query: (body) => ({
				method: 'GET',
				url: `/mw/email/inbox/short?${qs.stringify(body)}`,
			}),
			providesTags: [tags.email__inbox__short],
		}),
		emailReply: builder.mutation({
			query: (body) => ({
				method: 'POST',
				url: '/mw/email/reply',
				body,
				jsonType: true,
			}),
			providesTags: [tags.email__reply],
		}),
		emailForward: builder.mutation({
			query: (body) => ({
				method: 'POST',
				url: '/mw/email/forward',
				body,
				jsonType: true,
			}),
			providesTags: [tags.email__forward],
		}),
		emailCreate: builder.mutation({
			query: (body) => ({
				method: 'POST',
				url: '/mw/email/create',
				body,
			}),
			providesTags: [tags.email__create],
		}),
	}),
});

export const {
	emailAttachUpload,
	emailAttachDelete,
	emailAttachList,
	emailInboxShort,
	emailReply,
	emailForward,
	emailCreate,
} = emailApi.endpoints;

export default emailApi;
